import styled, {css} from 'styled-components'
import media from 'styled-media-query'

import {BoxProps} from "../BoxPlans/styles";
import Arrow from "../../../images/arrow-plans.svg";

export const Wrapper = styled.div<BoxProps>`
    ${({theme}) => css`
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        max-width: 94rem;
        background-color: ${theme.colors.altBg};
        border: 1px solid ${theme.colors.gray};
        padding: 3rem;
        margin: 15rem auto;
        border-radius: 80px 0 80px 80px;
        text-align: center;


        ${media.lessThan('medium')`
            padding: 2.5rem 1.5rem;
            border-radius: 60px 0 60px 60px;
        `}
    `}
`

export const Title = styled.div`
    ${({theme}) => css`
        font-family: ${theme.font.family};
        font-weight: ${theme.font.ultra};
        font-size: ${theme.font.sizes.xxlarge};
        line-height: 1.2;
        margin-bottom: 1.2rem;

        ${media.lessThan('medium')`
            font-size: calc(${theme.font.sizes.xlarge} + 0.6rem);
        `}
    `}
`

export const Content = styled.div`
    ${({theme}) => css`
        font-family: ${theme.font.family};
        font-weight: ${theme.font.normal};
        font-size: ${theme.font.sizes.medium};

        ${media.lessThan('medium')`
            font-size: ${theme.font.sizes.medium};
        `}
    `}
`

export const ArrowPremium = styled.div`
    position: absolute;
    right: -15px;
    top: -80px;
    width: 162px;
    height: 94px;
    background-image: url(${Arrow});
    background-repeat: no-repeat;
    transform: rotate(230deg);

    ${media.lessThan("medium")`
      right: -5px;
      top: -80px;
      transform: rotate(210deg);
  `}

`;

export const ArrowRight = styled.div`
    position: absolute;
    right: 15rem;
    top: -9rem;
    width: 16rem;
    height: 9rem;
    background-image: url(${Arrow});
    background-repeat: no-repeat;
    background-size: contain;
    transform: rotate(220deg);
    z-index: 2;

    ${media.lessThan("medium")`
        right: -1rem;
        top: -9rem;
        width: 12rem;
        transform: rotate(220deg);
    `}
`

export const ArrowLeft = styled.div`
    position: absolute;
    left: 2rem;
    top: -9rem;
    width: 16rem;
    height: 9rem;
    background-image: url(${Arrow});
    background-repeat: no-repeat;
    background-size: contain;
    transform: scaleX(-1) rotate(220deg);
    z-index: 2;

    ${media.lessThan("medium")`
    left: 0;
    top: -9rem;
    width: 12rem;
    transform: scaleX(-1) rotate(220deg);
  `}
`
